export const changeApp = clientId => {
	return {
		type: 'CHANGEAPP',
		payload: {
			clientId: clientId
		}
	}
};
